import { render } from "./animateModule.vue?vue&type=template&id=0bd8dad4"
import script from "./animateModule.vue?vue&type=script&lang=js"
export * from "./animateModule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__